import React, {useState,useEffect} from 'react';
import { NavLink } from 'react-router-dom';
import {useLocation} from 'react-router-dom'

import './leftNavComponent.css';
import './mobile.css'

import HomeIcon from '@material-ui/icons/Home';
import PersonIcon from '@material-ui/icons/Person';
import {ReactComponent as Logo} from '../../img/DominicLogo.svg'
import WebAssetIcon from '@material-ui/icons/WebAsset';
import InfoIcon from '@material-ui/icons/Info';
import ContactsIcon from '@material-ui/icons/Contacts';

import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';

import {motion} from 'framer-motion/dist/framer-motion'

function LeftNavComponent() { 
    let [width, setWidth] = useState(window.innerWidth);  
    let [isOpen, setOpen] = useState(false);
    const pathName = useLocation();
    const routes = [
        {
            id: 1,
            name: 'Home',
            props: HomeIcon,
            to: "/"

        },
        {
            id: 2,
            name: 'About',
            props: PersonIcon,
            to: "/About"


        },
        {
            id: 3,
            name: 'Projects',
            props: WebAssetIcon,
            to: "/Projects"

        },
        {
            id: 4,
            name: 'Skills',
            props: InfoIcon,
            to: "/Skills"

        },
        {
            id: 5,
            name: 'Contact',
            props: ContactsIcon,
            to: "/Contact"

        }
    ]

    useEffect(() => {
      window.addEventListener('resize',  function resizeWidth() {
          setWidth(window.innerWidth);
      })
    
      return () => {
        window.removeEventListener('resize',  function resizeWidth() {
            setWidth(window.innerWidth);
        })
      }
    }, [])
    
    useEffect(() => {
        if(isOpen) {
            setOpen(!isOpen)
        }

    }, [pathName])
    function overflowEnable() {
        if(width <= 960) {
            if(isOpen) {
                document.body.style.overflow = 'hidden'
            }
            else {
                document.body.style.overflow = 'initial'
            }
        }
        else{
            document.body.style.overflow = "initial"
        }
    }

    overflowEnable();
    return (
        <motion.header
        intial={{opacity: 0}}
        animate={{opacity: 1}}
        exit={{opacity: 0}}
        id="header" 
        className={'header__container ' + (isOpen ? 'open' : 'close')}
        >

            <div className="top header__logo">
                <Logo className="logo-icons" />
            </div>
            <div className="middle header__pages">
                {
                    routes.map(links => ((
                        <NavLink key={links.id} className="link" exact activeclassname ="active" to={links.to}>
                            
                            <div className="icon-container">
                                <links.props className="icons" />
                            </div>

                            <div className="nav_text_container">
                                <span className="textLink">{links.name}</span>
                            </div>
                        </NavLink>)
                    ))
                }

            </div>
            <div className="bottom header__social">
                <a className="link" activeclassname="active" href="https://www.facebook.com/dominic.gaona.52/">
                    <div className="icon-container">
                        <FacebookIcon className="icons" /> {/* Cotact me */}
                    </div>

                    <div className="nav_text_container">
                            <span className="textLink">Facebook</span>
                    </div>
                </a>

                <a className="link" activeclassname ="active" href="https://www.facebook.com/dominic.gaona.52/">
                    <div className="icon-container">
                        <TwitterIcon className="icons" /> {/* Cotact me */}
                    </div>
                    <div className="nav_text_container">
                        <span className="textLink">Twitter</span>
                    </div>
                </a>
            </div>
            <div className="mobileNav" style={isOpen ? {display:"block"} : {display:"none"}} onClick={() => {setOpen(!isOpen)}}>
                    <div className="hamburger-lines">

                    </div>
            </div>
        </motion.header>
    )
}

export default LeftNavComponent;
